/* istanbul ignore next */

/**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Column(_) {
  return null;
}

export default Column;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/sugar/Column.js
// module id = 490
// module chunks = 0